<template>
  <div class="components__rec-tabbed-conted">
    <TabbedContent v-bind:tab-headers="tabHeaders">
      <template v-for="tab in description.tabs" v-bind:key="tab.key" v-slot:[tab.key]>
        <component
          v-bind:is="tab.content.component"
          v-bind:description="tab.content"
          v-on:submit="$emit('submit')"
        />
      </template>
    </TabbedContent>
  </div>
</template>

<script lang="ts" setup>
 import { computed } from 'vue';

 import { recProps } from "../../mixins/rec-component";
 
 import TabbedContent from "vue/applications/frontend/components/tabbed-content.vue"

 const props = defineProps({...recProps()});
 defineEmits(["submit"]);

 const tabHeaders = computed(() => {
  const result: Record<string, string> = {};
  for (const tab of props.description.tabs || []) {
    result[tab.key] = tab.heading;
  }
  return result;
});
</script>
